import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { RouterState } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { JwtState } from '@stores/jwt/jwt.state';
import { WINDOW } from '@wizbii/angular-utilities';
import { combineLatest, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NotLoggedGuard implements CanActivate {
  constructor(
    private readonly store: Store,
    @Inject(WINDOW) private readonly window: any,
    @Inject(PLATFORM_ID) private readonly platformId: any
  ) {}

  canActivate(_: any, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([this.store.select(JwtState), this.store.select(RouterState.state)]).pipe(
      first(),
      map(([logged, currentState]) => {
        if (isPlatformServer(this.platformId)) {
          return true;
        }

        if (!logged) {
          this.window.open(
            `${environment.urls.account.signUp}${this.window.location.origin}/${FeaturesRoutingEnum.HelpForm}`,
            '_self'
          );
          return false;
        }

        return true;
      })
    );
  }
}
